export default __webpack_public_path__ + "static/media/landing-page-head-img-2.e6ead8ab.jpg";